import React                       from 'react';
import { useSelector }             from "react-redux";
import { ApplicationState }        from "../../../store";
import { LayoutState }             from "../../../store/layouts/types";
import WarningComponent            from "../../reusable/WarningComponent";
import CentralUIWrapperComponent   from "../CentralUIWrapperComponent";
import ExportShareComponent        from "../ExportShareComponent";
import LeftsideUIWrapperComponent  from "../LeftsideUIWrapperComponent";
import RightsideUIWrapperComponent from "../RightsideUIWrapperComponent";
import './style.css';

const {CONFIG} = window;


const FooterComponent = () => {
  const style = {
    height: CONFIG.footer.height + 'vh'
  };

  const {exportShareStatusIsOpened, warningExceptionIsOpened} = useSelector<ApplicationState, LayoutState>(state => state.layouts);

  return (
    <div className='footer'
         style={style}
    >
      <LeftsideUIWrapperComponent/>
      <CentralUIWrapperComponent/>
      <RightsideUIWrapperComponent/>
      {exportShareStatusIsOpened && <ExportShareComponent/>}
      {warningExceptionIsOpened && <WarningComponent/>}
    </div>
  )
};

export default FooterComponent;